
export class UADetector {

    public static isIPhone()
    {
        const ua = navigator.userAgent
        return (ua.indexOf('iPhone') > 0)
    }

    public static isIPad()
    {
        const ua = navigator.userAgent
        return (ua.indexOf('iPad') > 0)

    }

    public static isMobile() {
        var ua = navigator.userAgent;
        if (/iPad|Macintosh/i.test(ua) && 'ontouchend' in document) {
            // iPadOS devices are presented as Macintosh on a desktop mode, so we need an additional touch feature check.
            return true;
        } else if (/iPhone/i.test(ua)) {
            return true;
        } else if (/android/i.test(ua)) {
            return true;
        } else {
            return false;
        }
    }
}
